import Vue from 'vue';
import accountService from '@/modules/account-service';
import Subscription from '../models/subscription';
import { scopeSubFromDto } from '@/modules/scope-dto';
import Plan from '../models/plan';

const GET_SUBSCRIPTION_REQUEST = 'GET_SUBSCRIPTION_REQUEST',
	GET_SUBSCRIPTION_SUCCESS = 'GET_SUBSCRIPTION_SUCCESS',
	GET_SUBSCRIPTIONS_REQUEST = 'GET_SUBSCRIPTIONS_REQUEST',
	CHANGE_SUBSCRIPTION_REQUEST = 'CHANGE_SUBSCRIPTION_REQUEST',
	CHANGE_SUBSCRIPTION_SUCCESS = 'CHANGE_SUBSCRIPTION_SUCCESS',
	ADD_SUBSCRIPTION_REQUEST = 'ADD_SUBSCRIPTION_REQUEST',
	ADD_SUBSCRIPTION_SUCCESS = 'ADD_SUBSCRIPTION_SUCCESS',
	ADD_PROMOTION_REQUEST = 'ADD_PROMOTION_REQUEST',
	GET_PROMOTION_REQUEST = 'GET_PROMOTION_REQUEST',
	POST_PROMOTION_REQUEST = 'POST_PROMOTION_REQUEST',

	GET_TEK_SUBSCRIPTIONS_REQUEST = 'GET_TEK_SUBSCRIPTIONS_REQUEST',

	//shared
	SET_SCOPE_REDIRECT = 'SET_SCOPE_REDIRECT',
	SET_DRIVE_REDIRECT = 'SET_DRIVE_REDIRECT',
	GET_SUBSCRIPTIONS_SUCCESS = 'GET_SUBSCRIPTIONS_SUCCESS',
	ADD_SUBSCRIPTION_ERROR = 'ADD_SUBSCRIPTION_ERROR',
	GET_SUBSCRIPTION_ERROR = 'GET_SUBSCRIPTION_ERROR',
	CHANGE_SUBSCRIPTION_ERROR = 'CHANGE_SUBSCRIPTION_ERROR',
	GET_SUBSCRIPTIONS_ERROR = 'GET_SUBSCRIPTIONS_ERROR',
	DISCOUNT_PLANS = 'DISCOUNT_PLANS',
	SET_PLANS = 'SET_PLANS',
	REMOVE_SUBSCRIPTION = 'REMOVE_SUBSCRIPTION',
	SET_INTERVAL_OPTIONS = 'SET_INTERVAL_OPTIONS',
	TEAR_DOWN = 'TEAR_DOWN',
	RESET_PLANS_STATE = 'RESET_PLANS_STATE',
	STORE_SELECTION = 'STORE_SELECTION',
	CLEAR_SELECTION = 'CLEAR_SELECTION',
	RESET_CHANGE_SUBSCRIPTION_STATUS = 'RESET_CHANGE_SUBSCRIPTION_STATUS';

const state = {
	plans: [],
	initialPlans: [],
	initialIntervalOptions: [],
	prepaidPlan: null,
	intervalOptions: [],
	currentSubscription: null,
	subscriptions: [],
	selection: null,
	updatedSubscription: {},
	getSubscriptionStatus: {},
	getSubscriptionsStatus: {},
	changeSubscriptionStatus: {},
	redirectToDrive: false,
	redirectToScope: false
};

const getters = {
	subscriptions: state => state.subscriptions,
	plans: state => state.plans,
	// currentSubscription: state => state.currentSubscription,
	iotSubscription: (state, getters, rootState, rootGetters) => {
		const iotSub =  state.subscriptions && state.subscriptions.find(sub=> {
			return sub && sub.plan.id.includes('iot');
		});
		return Subscription.fromDTO(iotSub);
	},
	scopeSubscriptions: (state, getters, rootState, rootGetters) => {
		return state.subscriptions && state.subscriptions.filter(sub=> {
			return sub && sub.plan.id.includes('scope');
		});
	},
	driveSubscriptions: (state, getters, rootState, rootGetters) => {
		return state.subscriptions && state.subscriptions.filter(sub=> {
			return sub && sub.plan.id.includes('tekdrive');
		});
	},
	hasLegacyTekScopeWithNoNewPromo: (state, getters, rootState, rootGetters) => {
		const offerStartDate = new Date('2024-06-21T00:00:00.00Z');
		// has a new sub post offer start
		const redeemedPromo = getters.scopeSubscriptions && getters.scopeSubscriptions.find(sub=> {
			return +new Date(sub?.created) > +offerStartDate;
		});
		// has a legacy sub
		const legacyScopeSubs = getters.scopeSubscriptions && getters.scopeSubscriptions.filter(sub=> {
			return sub?.plan?.id.includes('base');
		});
		return legacyScopeSubs.length > 0 && !redeemedPromo;
	},
	updatedSubscription: state => state.updatedSubscription || {},
	getSubscriptionStatus: state => state.getSubscriptionStatus || {},
	getSubscriptionsStatus: state => state.getSubscriptionsStatus || {},
	changeSubscriptionStatus: state => state.changeSubscriptionStatus || {}
};

function getSubscriptionIndex(sub) {
	let subId = sub.id || sub;
	const element = state.subscriptions.find(item => {
		return item.id === subId ;
	});
	return state.subscriptions.indexOf(element);
}

function getSubById(subs, subId) {
	return subs && subs.find(sub=> {
		return sub && sub.id === subId;
	});
}

function deepCopy(obj) {
	return JSON.parse(JSON.stringify(obj));
}

const actions = {
	'PURCHASE_EXTENSION_AND_POLL_STATUS': (context, { subscriptionId, maintenanceExtensionId, quantity}) => {
		return accountService.purchaseExtensionAndPollStatus(subscriptionId, maintenanceExtensionId, quantity);
	},
	[GET_SUBSCRIPTIONS_REQUEST]: ({ commit, dispatch, rootGetters, getters }) => {
		commit(GET_SUBSCRIPTIONS_REQUEST);

		const subs = state.subscriptions.length && state.subscriptions;

		if (subs) {
			commit(GET_SUBSCRIPTIONS_SUCCESS, subs);
			return;
		}

		return accountService.getSubscriptions()
			.then(response => {
				let subs = response.data.subscriptions;
				commit(GET_SUBSCRIPTIONS_SUCCESS, subs);

				return Promise.resolve(subs);
			})
			.catch(error => {
				commit(GET_SUBSCRIPTIONS_ERROR);
				return Promise.reject(error);
			});
	},
	[GET_TEK_SUBSCRIPTIONS_REQUEST]: ({ commit, dispatch, rootGetters, getters }, clearCache) => {
		commit(GET_SUBSCRIPTIONS_REQUEST);

		const subs = state.subscriptions.length && state.subscriptions;

		if (subs && !clearCache) {
			commit(GET_SUBSCRIPTIONS_SUCCESS, subs);
			return Promise.resolve(subs);
		}

		return accountService.getSubscriptions()
			.then(response => {
				let subs = response.data.subscriptions;
				commit(GET_SUBSCRIPTIONS_SUCCESS, subs);
				return subs;
			})
			.catch(error => {
				commit(GET_SUBSCRIPTIONS_ERROR);
				return error;
			});
	},
	[GET_SUBSCRIPTION_REQUEST]: ({ commit, dispatch, getters, rootGetters }, {product , subId}) => {
		commit(GET_SUBSCRIPTION_REQUEST);

		accountService.getPlans(product)
			.then((planResponse) => {
				let billingOptions = [];
				let planData = deepCopy(planResponse.data.plans).map(Plan.fromDTO);

				commit('SET_PLANS', planData);

				planData.forEach(plan => {

					plan.billingCycles.forEach(cycle => {
						let added = billingOptions.includes(cycle.interval);

						if (!added) {
							if (cycle.interval === 'free' && !billingOptions.includes('monthly')) {
								// free falls under the monthly interval
								billingOptions.push('monthly');
							} else if (cycle.interval !== 'free')  {
								billingOptions.push(cycle.interval);
							}
						}
					});

					billingOptions.sort();
				});

				dispatch('SET_INTERVAL_OPTIONS', billingOptions);

				dispatch(GET_SUBSCRIPTIONS_REQUEST)
					.then(() => {
						const current = getters[product + 'Subscription'];
						commit(GET_SUBSCRIPTION_SUCCESS, current);
					});
			})
			.catch(error => {
				commit(GET_SUBSCRIPTION_ERROR, error);
			});
	},
	[CHANGE_SUBSCRIPTION_REQUEST]: ({ commit, dispatch, rootGetters }, payload) => {
		return new Promise((resolve, reject) => {
			commit(CHANGE_SUBSCRIPTION_REQUEST);
			accountService.changeSubscription(payload)
				.then(response => {
					dispatch(CHANGE_SUBSCRIPTION_SUCCESS, response);

					resolve(response);
				})
				.catch(error => {

					commit(CHANGE_SUBSCRIPTION_ERROR, error);
					reject(error);
				});
		});
	},
	[CHANGE_SUBSCRIPTION_SUCCESS]: ({ commit, dispatch, rootGetters }, payload) => {
		dispatch('ACCOUNT_REQUEST', null, {root:true});
		commit(CHANGE_SUBSCRIPTION_SUCCESS, payload);
	},
	[ADD_SUBSCRIPTION_SUCCESS]: ({ commit, dispatch, rootGetters }, payload) => {
		dispatch('ACCOUNT_REQUEST', null, {root:true});
		commit(ADD_SUBSCRIPTION_SUCCESS, payload);
	},
	[ADD_SUBSCRIPTION_REQUEST]: ({ commit, dispatch, rootGetters }, payload) => {
		return new Promise((resolve, reject) => {
			commit(ADD_SUBSCRIPTION_REQUEST);
			accountService.addSubscription(payload)
				.then(response => {
					const sub = Subscription.fromDTO(response);
					dispatch(ADD_SUBSCRIPTION_SUCCESS, sub);
					resolve(response);
				})
				.catch(error => {
					commit(ADD_SUBSCRIPTION_ERROR, error);
					reject(error);
				});
		});
	},
	[ADD_PROMOTION_REQUEST]: ({commit, dispatch}, promoCode) => {
		let strings =  Buffer.from(promoCode, 'base64').toString().split(':'),
			product = strings[0];

		// if no model and serial are present, they must use their account to verify with a GET request
		if (strings.length === 1) {
			return dispatch(GET_PROMOTION_REQUEST, product);
		}
		return dispatch(POST_PROMOTION_REQUEST, promoCode);
	},
	[GET_PROMOTION_REQUEST]: ({ commit, dispatch, rootGetters, getters }, promoName) => {

		return accountService.getPromotion(promoName)
			.then(response => {
				return dispatch(POST_PROMOTION_REQUEST, response.promoCode);
			})
			.catch(error => {
				return Promise.reject(error);
			});
	},
	[POST_PROMOTION_REQUEST]: ({ commit, dispatch, rootGetters, getters }, promoCode) => {
		return accountService.addPromotion({ promoCode })
			.then(response => {
				dispatch(GET_TEK_SUBSCRIPTIONS_REQUEST, true);
				return Promise.resolve();
			})
			.catch(error => {
				return Promise.reject(error);
			});
	},
	[SET_DRIVE_REDIRECT]:({ commit, dispatch }, redirect) => {
		commit(SET_DRIVE_REDIRECT, redirect);
	},
	[SET_SCOPE_REDIRECT]:({ commit, dispatch }, redirect) => {
		commit(SET_SCOPE_REDIRECT, redirect);
	},
	[STORE_SELECTION]:({ commit, dispatch }, selection) => {
		commit(STORE_SELECTION, selection);
	},
	[CLEAR_SELECTION]:({ commit, dispatch }) => {
		commit(CLEAR_SELECTION, null);
	},
	[REMOVE_SUBSCRIPTION]:({ commit, dispatch }, subId) => {
		commit(REMOVE_SUBSCRIPTION, subId);
	},
	[RESET_PLANS_STATE]: ({commit, dispatch}) => {
		// if initial plans are available set them now
		if (state.initialPlans.length) {
			commit(RESET_PLANS_STATE, state.initialPlans);
		}
		// if initial interval options are available set them now
		if (state.initialIntervalOptions.length) {
			dispatch('SET_INTERVAL_OPTIONS', state.initialIntervalOptions);
		}
	},
	[TEAR_DOWN]: ({ commit, dispatch }, options) => {
		commit('TEAR_DOWN');
	},
	[SET_INTERVAL_OPTIONS]: ({ commit, dispatch }, options) => {
		commit('SET_INTERVAL_OPTIONS', options);
	},
	[RESET_CHANGE_SUBSCRIPTION_STATUS]: ({ commit, dispatch}) => {
		commit(RESET_CHANGE_SUBSCRIPTION_STATUS);
	},
};

const mutations = {

	[GET_SUBSCRIPTION_REQUEST]: (state) => {
		state.getSubscriptionStatus = {
			loading: true
		};
	},
	[GET_SUBSCRIPTION_SUCCESS]: (state, current) => {
		state.getSubscriptionStatus = {
			success: true
		};

		state.currentSubscription = current;
	},
	[GET_SUBSCRIPTION_ERROR]: (state) => {
		state.getSubscriptionStatus = {
			error: true
		};
	},
	[SET_PLANS]: (state, plans) => {
		if (!state.initialPlans.length) {
			state.initialPlans = plans.slice();
		}

		state.plans = plans;
	},
	[TEAR_DOWN]: (state) => {
		state.initialIntervalOptions = [];
		state.initialPlans = [];
		state.scopeSubscription = null;
		state.currentSubscription = null;
		state.driveSubscription = null;
		state.changeSubscriptionStatus = {};
	},
	[SET_INTERVAL_OPTIONS]: (state, options) => {
		//store original interval options
		if (!state.initialIntervalOptions.length) {
			state.initialIntervalOptions = options.slice();
		}
		state.intervalOptions = options;
	},
	[GET_SUBSCRIPTIONS_REQUEST]: (state) => {
		state.getSubscriptionsStatus = {
			loading: true
		};
	},
	[GET_SUBSCRIPTIONS_SUCCESS]: (state, subs) => {
		state.getSubscriptionsStatus = {
			success: true
		};

		Vue.set(state, 'subscriptions', subs);
	},
	[GET_SUBSCRIPTIONS_ERROR]: (state) => {
		state.getSubscriptionsStatus = {
			error: true
		};
	},
	[DISCOUNT_PLANS]: (state, plans) => {
		Vue.set(state, 'plans', plans);
		state.plans.discounted = true;
	},
	[CHANGE_SUBSCRIPTION_REQUEST]: (state) => {
		state.changeSubscriptionStatus = {
			loading: true
		};
	},
	[RESET_PLANS_STATE]: (state, plans) => {
		Vue.set(state, 'plans', plans);
	},
	[CHANGE_SUBSCRIPTION_SUCCESS]: (state, response) => {
		state.changeSubscriptionStatus = {
			success: true
		};
		const index = getSubscriptionIndex(response);
		Vue.set(state.subscriptions, index, response);
		state.currentSubscription = Subscription.fromDTO(response);
	},
	[CHANGE_SUBSCRIPTION_ERROR]: (state, response) => {
		state.changeSubscriptionStatus = {
			error: response
		};
	},
	[ADD_SUBSCRIPTION_REQUEST]: (state) => {
		state.changeSubscriptionStatus = {
			loading: true
		};
	},
	[REMOVE_SUBSCRIPTION]: (state, subId) => {
		const index = getSubscriptionIndex(subId);
		state.subscriptions.splice(index, 1);
	},
	[STORE_SELECTION]: (state, selection) => {
		state.selection = deepCopy(selection);
	},
	[CLEAR_SELECTION]: (state, selection) => {
		state.selection = selection;
	},
	[SET_DRIVE_REDIRECT]: (state, redirect) => {
		state.redirectToDrive = redirect;
	},
	[SET_SCOPE_REDIRECT]: (state, redirect) => {
		state.redirectToScope = redirect;
	},
	[ADD_SUBSCRIPTION_SUCCESS]: (state, response) => {
		state.changeSubscriptionStatus = {
			success: true
		};
		//set as first subscription
		state.subscriptions.push(response);
		state.currentSubscription = response;
	},
	[ADD_SUBSCRIPTION_ERROR]: (state, response) => {
		state.changeSubscriptionStatus = {
			error: response
		};
	},
	[RESET_CHANGE_SUBSCRIPTION_STATUS]: (state) => {
		state.selection = null;
		state.changeSubscriptionStatus = {};
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/subscription.js